import type { Signal } from "@suse-o11y/signal";
import { createContext } from "react";

export interface SouthPaneState {
	isOpen: Signal<boolean>;
}

export const SouthPaneContext = createContext<null | SouthPaneState>(null);
